// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"03827143f7065f31","9732":"982a2a40a0080442"}[chunkId] + ".css";
};